module.exports = __webpack_public_path__ + "static/Roboto-BoldItalic-9098d3de14ef1cfae7be4f195fe1a174.ttf";